<template>
  <div style="text-align: left;">
    <h2>Sign Up</h2>
    <form @submit.prevent="signup">
      <div>
        <label for="name">Username</label><br>
        <input type="text" v-model="name" required />
      </div>
      <div>
        <label for="password">Password</label><br>
        <input type="password" v-model="password" required />
      </div>
      <div>
        <label for="disp_name">Display Name</label><br>
        <input type="text" v-model="disp_name" required />
      </div>
      <div>
        <label for="email">Email</label><br>
        <input type="email" v-model="email" required />
      </div>
      <div>
        <label for="gpg_pub_key">GPG Public Key</label><br>
        <textarea type="text" v-model="gpg_pub_key" />
      </div>
      <br>
      <button type="submit">Sign Up</button>
    </form>
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import config from '../config';

const route = useRoute();
const token = ref(route.query.token || "");

const name = ref("");
const password = ref("");
const disp_name = ref("");
const email = ref("");
const gpg_pub_key = ref("");
const message = ref("");
const error = ref("");

const signup = async() => {
  try {
    const response = await fetch(`${ config.apiBaseUrl }/users/signup`, {method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: token.value,
        name: name.value,
        password: password.value,
        disp_name: disp_name.value,
        email: email.value,
        gpg_pub_key: gpg_pub_key.value || null,
      }),
    });

    const result = await response.json();

    if (response.ok) {
      message.value = "Sign-up successful!";
      alert("Registration Complete. Redirecting to login.");

      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    } else {
      message.value = result.error || "Sign-up failed.";
    }
  } catch (error) {
    message.value = "Network error. Please try again.";
  }
}
</script>
